import StepPaymentInfoForm from './stepPaymentInfoForm';

export default StepPaymentInfoForm;
